import React, { useState, useRef } from 'react';
import { Play, Volume2, VolumeX, Maximize2 } from 'lucide-react';

const videoSrc = require('../../../../assets/videos/home.webm');

const VideoSection: React.FC = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [isMuted, setIsMuted] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);

  const togglePlayPause = () => {
    if (!videoRef.current) return;
    if (videoRef.current.paused) {
      videoRef.current.play();
    } else {
      videoRef.current.pause();
    }
  };

  const handleToggleMute = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!videoRef.current) return;
    const newMuted = !isMuted;
    videoRef.current.muted = newMuted;
    setIsMuted(newMuted);
  };

  const handleFullscreen = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (videoRef.current?.requestFullscreen) {
      videoRef.current.requestFullscreen();
    }
  };

  return (
    <div
      className={`video relative  w-[87%] aspect-video lg:h-[80vh] my-8 mx-auto bg-black rounded-2xl overflow-hidden cursor-none ${
        isPlaying ? 'pause' : 'play'
      }`}
      data-cursor-video="true"
      data-is-playing={isPlaying}
      onClick={togglePlayPause}
    >
      <video
        ref={videoRef}
        src={videoSrc}
        loop
        muted={isMuted}
        playsInline
        poster={require('../../../../assets/images/poster.webp')}
        preload="metadata"
        onPlay={() => setIsPlaying(true)}
        onPause={() => setIsPlaying(false)}
        className="w-full h-full object-cover"
      />

      {/* Play overlay */}
      {!isPlaying && (
        <div className="play absolute lg:hidden top-[calc(50%-50px)] left-[calc(50%-50px)] bg-white/20 backdrop-blur-md border border-white/30 rounded-full w-[100px] h-[100px] flex justify-center items-center text-white animate-pulse-custom z-8 pointer-events-none">
          <Play size={40} />
        </div>
      )}

      {/* Mute/unmute button (always visible) */}
      <button
        onClick={handleToggleMute}
        className="absolute bottom-5 left-5 bg-black/50 border-none rounded-lg text-white p-2.5 cursor-pointer z-8 focus:outline-none"
      >
        {isMuted ? <VolumeX size={24} /> : <Volume2 size={24} />}
      </button>

      {/* Fullscreen button (when playing) */}
      {isPlaying && (
        <button
          onClick={handleFullscreen}
          className="absolute bottom-5 right-5 bg-black/50 border-none rounded-lg text-white p-2.5 cursor-pointer z-8 focus:outline-none"
        >
          <Maximize2 size={24} />
        </button>
      )}
    </div>
  );
};

export default VideoSection;